import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getOneAllergy } from "../../../../../../../../store/actions";
import { useParams, useHistory } from "react-router-dom";
import View from "../../Repeated-Component/View";
import { useToast } from "@chakra-ui/react";

const ViewOneAllergie = ({ getOneAllergy, OneAllergy, patient }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [allergy, setAllergy] = useState(null);
  const { medicalId } = useParams();
  const toast = useToast();
  let history = useHistory();

  useEffect(() => {
    if (medicalId && patient) {
      getOneAllergy(medicalId, toast, history, patient.id);
    }
  }, []);

  useEffect(() => {
    const { loading, error, data } = OneAllergy;
    setLoading(loading);
    setError(error);
    if (data) {
      setAllergy(data);
    }
  }, [OneAllergy]);
  const renderView = () => {
    return (
      <View
        loading={loading}
        error={error}
        headerText="View Condition"
        one={allergy}
        history={history}
      />
    );
  };
  return renderView();
};
const mapStateToProps = (state) => {
  return {
    OneAllergy: state.OneAllergy,
  };
};
export default connect(mapStateToProps, { getOneAllergy })(ViewOneAllergie);
